<!-- eslint-disable max-len -->
<template>
  <div
    :id="id"
    class="properties-field"
  >
    <div class="wrap-properties">
      <!-- Configuration Title -->
      <div class="properties-field-title">
        <h4 class="title">Properties</h4>
        <div
          class="close-properties"
          @click="submitForm(true)"
        >
          &times;
        </div>

        <div class="wrap-type">
          <img :src="require(`@/assets/new-form-ui/field-icon/${fieldDetail.type === 'form_ui' ? 'single' : 'multiple'}_experience_manager.svg`)">
          <div class="text-type">
            {{ fieldDetail.type === 'form_ui' ? 'Single' : 'Multiple' }} Experience Manager
          </div>
        </div>
      </div>

      <!-- Content Properties -->
      <div class="properties-field-content">
        <div class="section-field input-field">
          <b-form :class="{'error-input' : $v.dataSetup.title.$error}">
            <label>Title</label>
            <j-input
              v-model="dataSetup.title"
              placeholder="Ex: List Data..."
            />
          </b-form>

          <b-form :class="{'error-input' : $v.dataSetup.form_ui.$error}">
            <label> Experience Manager</label>
            <j-single-select
              v-model="dataSetup.form_ui"
              :load-options="loadOptionsFormUI"
              :is-async="true"
              :cache-option="false"
              :placeholder="'Experience Manager'"
              value-format="object"
              label="name"
            />
          </b-form>
        </div>

        <!-- View -->
        <div class="section-field input-field">
          <h4 class="title-section">Primary View</h4>

          <!-- List view web -->
          <div
            :class="{'error-input' : $v.dataSetup.selected_view.$error}"
            class="configuration-section"
          >
            <h4 class="configuration-section-title mb-2">Web</h4>

            <div
              v-if="list_view.length > 0 || !isLoading"
              class="div-view"
            >
              <div
                v-for="view in list_view"
                :key="view.id"
                :class="{
                  'active': dataSetup.selected_view && dataSetup.selected_view.id === view.id,
                  'disabled': !view.hasSetup
                }"
                class="view"
                @click="selectView(view, true)"
              >
                <img
                  v-if="dataSetup.selected_view && dataSetup.selected_view.id === view.id"
                  :src="require(`@/assets/new-form-ui/icon-active/${view.icon}.svg`)"
                >
                <img
                  v-else
                  :src="require(`@/assets/new-form-ui/icon/${view.icon}.svg`)"
                >
                <span>{{ view.name }}</span>
              </div>
            </div>

            <div
              v-if="list_view.length === 0"
              class="warning-function d-flex align-items-center">
              <img src="@/assets/icon/warning.svg" >
              <div class="d-flex flex-column">
                <span>Please select <b>Experience Manager</b> first!</span>
              </div>
            </div>
          </div>

          <!-- List view mobile -->
          <div
            :class="{'error-input' : $v.dataSetup.selected_view_small.$error}"
            class="configuration-section"
          >
            <h4 class="configuration-section-title mb-2">Mobile</h4>

            <div
              v-if="list_view_small.length > 0 || !isLoading"
              class="div-view"
            >
              <div
                v-for="view in list_view_small"
                :key="view.id"
                :class="{
                  'active': dataSetup.selected_view_small && dataSetup.selected_view_small.id === view.id,
                  'disabled': !view.hasSetup
                }"
                class="view"
                @click="selectView(view, false)"
              >
                <img
                  v-if="dataSetup.selected_view_small && dataSetup.selected_view_small.id === view.id"
                  :src="require(`@/assets/new-form-ui/icon-active/${view.icon}.svg`)"
                >
                <img
                  v-else
                  :src="require(`@/assets/new-form-ui/icon/${view.icon}.svg`)"
                >
                <span>{{ view.name }}</span>
              </div>
            </div>

            <div
              v-if="list_view_small.length === 0"
              class="warning-function d-flex align-items-center">
              <img src="@/assets/icon/warning.svg" >
              <div class="d-flex flex-column">
                <span>Please select <b>Experience Manager</b> first!</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Parse Value -->
        <div class="section-field input-field">
          <h4 class="title-section">Parse value to</h4>

          <div
            v-if="!isLoading"
            class="d-flex"
          >
            <b-form-group :class="{'error-input' : $v.dataSetup.filter_variable.$error}">
              <label> Column (This Component) </label>
              <j-single-select
                v-model="dataSetup.filter_column"
                :options="list_filter_column"
                label="label"
                value-format="object"
                placeholder="Select Column"
              />
            </b-form-group>

            <img
              src="@/assets/new-form-ui/equal.svg"
              class="equal"
            >

            <b-form-group :class="{'error-input' : $v.dataSetup.filter_column.$error}">
              <label> Column (Main UI) </label>
              <j-single-select
                v-model="dataSetup.filter_variable"
                :options="options"
                label="label"
                value-format="object"
                placeholder="Select Column"
              />
            </b-form-group>
          </div>

          <!-- If Loading -->
          <div
            v-else
            class="d-flex"
          >
            <b-form-group>
              <label> Column (This Component) </label>
              <j-single-select
                :disabled="true"
                placeholder="Select Column"
              />
            </b-form-group>

            <img
              src="@/assets/new-form-ui/equal.svg"
              class="equal"
            >

            <b-form-group>
              <label> Column (Main UI) </label>
              <j-single-select
                :disabled="true"
                placeholder="Select Column"
              />
            </b-form-group>
          </div>
        </div>
      </div>

      <!-- Button Properties -->
      <div
        :class="{ 'justify-content-end': !fieldDetail }"
        class="properties-field-button"
      >
        <button
          v-if="fieldDetail"
          class="button-border"
          @click="deleteConfiguration"
        >
          <i class="fa fa-trash" /> Delete
        </button>

        <div class="d-flex align-items-center">
          <button
            class="button-border mr-2"
            @click="submitForm(true)"
          >
            Close
          </button>

          <button
            class="button-blue"
            @click="submitForm(false)"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable max-len, no-unused-vars, no-nested-ternary, no-console, camelcase */
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import jwtDecode from 'jwt-decode';
import jMixAutoScroll from '@/mixins/jMixAutoScroll';

export default {
  name: 'ComponentCofiguration',

  mixins: [jMixAutoScroll],

  validations: {
    dataSetup: {
      type: {
        required,
      },
      title: {
        required,
      },
      form_ui: {
        required,
      },
      selected_view: {
        required,
      },
      selected_view_small: {
        required,
      },
      filter_column: {
        required,
      },
      filter_variable: {
        required,
      },
    },
  },

  props: {
    id: {
      type: String,
      default: '',
    },
    fieldDetail: {
      type: Object,
      default: () => {},
    },
    options: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      isFirstLoad: true,
      isLoading: true,
      dataSetup: {
        type: null,
        title: '',
        form_ui: null,
        selected_view: null,
        selected_view_small: null,
        filter_column: null,
        filter_variable: null,
      },
      list_view: [],
      list_view_small: [],
      list_filter_column: [],
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
    };
  },

  watch: {
    // eslint-disable-next-line
    'dataSetup.form_ui': function(data) {
      if (!this.isFirstLoad) {
        this.dataSetup.selected_view = null;
        this.dataSetup.selected_view_small = null;
        this.dataSetup.filter_column = null;
        this.dataSetup.filter_variable = null;

        this.getData(data);
      }
    },
  },

  created() {
    if (this.fieldDetail) {
      if (this.fieldDetail.info) {
        const info = JSON.parse(this.fieldDetail.info);
        const dataFilter = {
          id: this.fieldDetail.type === 'multiple_form_ui' ? info.multiple_form_ui_id : info.form_ui_id,
          company_id: this.session.user.company_id,
        };
        const reqData = {
          limit: 5,
          page: 1,
          filter: JSON.stringify(dataFilter),
        };
        const action = this.fieldDetail.type === 'multiple_form_ui' ? 'findMultiFormUi' : 'findFormUi';
        this[action](reqData).then((res) => {
          const dataFormUi = res[0];
          dataFormUi.label = dataFormUi.name;

          this.dataSetup.form_ui = dataFormUi;
          this.dataSetup.selected_view = { id: info.default_view };
          this.dataSetup.selected_view_small = { id: info.default_view_small };
          this.dataSetup.filter_column = { id: info.filter_column };
          this.dataSetup.filter_variable = { id: info.filter_variable };

          this.getData(dataFormUi);
        });
        this.dataSetup.title = this.fieldDetail.name;
      } else if (!this.fieldDetail.info) {
        if (this.isFirstLoad) this.isFirstLoad = false;
      }

      this.dataSetup.type = {
        id: this.fieldDetail.component_master_id,
        name: this.fieldDetail.type,
      };
    } else {
      this.dataSetup = {
        type: null,
        title: '',
        form_ui: null,
        selected_view: null,
        selected_view_small: null,
        filter_column: null,
        filter_variable: null,
      };
    }
  },

  methods: {
    ...mapActions('jStoreFormUi', ['findFormData', 'findFormUi', 'findMultiFormUi']),

    getData(form_ui) {
      if (form_ui) {
        const notIncluded = ['kanban_card_view', 'kanban_table_view', 'report_view', 'map_view', 'chart_view', 'import_view', 'create_requester_view', 'create_approver_view', 'detail_requester_view', 'detail_approver_view'];
        if (this.fieldDetail.type !== 'form_ui') notIncluded.push('detail_view');
        const filtered = Object.keys(form_ui).filter(key => key.includes('view') && !notIncluded.includes(key));

        const filteredList = filtered.map(el => ({
          id: el,
          name: el.replace('_view', '').replace(/_/g, ' ').replace(/^./, el[0].toUpperCase()).replace('requester', 'Requester')
            .replace('approver', 'Approver'),
          icon: el.replace('_view', '').split('_')[0],
          hasSetup: !!form_ui[el],
        }));

        this.list_view = filteredList.filter(e => !e.id.includes('list'));
        this.list_view_small = filteredList;
        this.list_filter_column = [];

        if (form_ui.form_data_id) {
          const param = {
            form_data_id: form_ui.form_data_id,
          };
          this.findFormData(param).then((res) => {
            const listColumns = Object.keys(res.data.columns);
            const listColumnsVal = Object.values(res.data.columns);

            if (listColumns.length > 0) {
              listColumns.forEach((column, index) => {
                if (listColumnsVal[index].type !== '[]attachment') {
                  this.list_filter_column.push({
                    id: column,
                    label: column,
                    text: column,
                  });
                }
              });
            }
            if (this.isFirstLoad) this.isFirstLoad = false;
          });
        } else {
          const listColumns = Object.keys(form_ui.data_source.external_url.columns);
          const listColumnsVal = Object.values(form_ui.data_source.external_url.columns);

          if (listColumns.length > 0) {
            listColumns.forEach((column, index) => {
              if (listColumnsVal[index].type !== '[]attachment') {
                this.list_filter_column.push({
                  id: column,
                  label: column,
                  text: column,
                });
              }
            });
          }
          setTimeout(() => {
            if (this.isFirstLoad) this.isFirstLoad = false;
          }, 500);
        }
      } else {
        this.list_view = [];
        this.list_view_small = [];
        if (this.isFirstLoad) this.isFirstLoad = false;
      }

      if (this.isLoading) this.isLoading = false;
    },

    loadOptionsFormUI({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH && searchQuery !== null) {
        if (searchQuery.length > 2) {
          const dataFilter = {
            name: searchQuery,
            company_id: this.session.user.company_id,
          };
          const reqData = {
            limit: 100,
            page: 1,
            filter: JSON.stringify(dataFilter),
          };
          if (this.dataSetup.type.name === 'multiple_form_ui') {
            this.$store.dispatch('jStoreFormUi/actionGetMultiFormUiListAsync', { reqData, callback });
          } else {
            this.$store.dispatch('jStoreFormUi/actionGetFormUiListAsync', { reqData, callback });
          }
        } else {
          callback(null, false);
        }
      }
    },

    genData() {
      const dataField = {
        default_view: this.dataSetup.selected_view.id,
        default_view_small: this.dataSetup.selected_view_small.id,
        filter_column: this.dataSetup.filter_column.id,
        filter_variable: this.dataSetup.filter_variable.id,
      };
      if (this.dataSetup.type.name === 'multiple_form_ui') {
        dataField.multiple_form_ui_id = this.dataSetup.form_ui.id;
        dataField.multiple_form_ui_name = this.dataSetup.form_ui.name;
      } else {
        dataField.form_ui_id = this.dataSetup.form_ui.id;
        dataField.form_ui_name = this.dataSetup.form_ui.name;
      }

      return {
        name: this.dataSetup.title,
        type: this.dataSetup.type.name,
        component_master_id: this.dataSetup.type.id,
        info: JSON.stringify(dataField),
      };
    },

    selectView(payload, isWeb) {
      if (payload.hasSetup) {
        const data = {
          id: payload.id,
          label: `${payload.name} view`,
          name: `${payload.name} view`,
        };
        if (isWeb) this.dataSetup.selected_view = data;
        else this.dataSetup.selected_view_small = data;
      }
    },

    submitForm(isCancel) {
      if (!isCancel) {
        this.$v.dataSetup.$touch();
        if (!this.$v.dataSetup.$error) {
          this.$emit('submit-mode', this.genData(), isCancel);
        }
      } else {
        this.$emit('submit-mode', this.fieldDetail, isCancel);
      }
    },

    deleteConfiguration() {
      this.$emit('delete-configuration');
    },

    closeConfiguration() {
      this.$emit('close-configuration');

      setTimeout(() => {
        this.dataSetup = {
          type: null,
          title: '',
          form_ui: null,
          selected_view: null,
          selected_view_small: null,
          filter_column: null,
          filter_variable: null,
        };
      }, 400);
    },
  },
};
</script>

<style lang="scss" scoped>
  .warning-function {
    padding: 12px;
    border-radius: 8px;
    background-color: #FFFDED;
    color: #696014;

    img {
      width: auto;
      height: 16px;
      margin-right: 8px;
    }
  }

  .equal {
    width: 16px;
    height: auto;
    margin-left: 15px;
    margin-right: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/views/experience-manager-v2/partials/configuration/ComponentConfiguration.vue